import '@src/styles/rdr/styles.css';
import '@src/styles/rdr/default.css';

import React from 'react';
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import {DateRangePicker as BaseDateRangePicker} from "react-date-range";

const toDate = (value) => {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value;
  }

  if (typeof value === 'number' || typeof value === 'string') {
    const parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed;
    }
  }

  return null;
};

function DateRangePicker({ startDate, endDate, onChange }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const safeStartDate = React.useMemo(() => toDate(startDate) ?? new Date(), [startDate]);
  const safeEndDate = React.useMemo(
    () => {
      const parsedEnd = toDate(endDate);
      if (!parsedEnd) {
        return safeStartDate;
      }

      return parsedEnd < safeStartDate ? safeStartDate : parsedEnd;
    },
    [endDate, safeStartDate],
  );
  React.useEffect(() => {
    console.log('[DateRangePicker] Incoming props', {
      startDate,
      endDate,
      safeStartDate: safeStartDate?.toISOString?.(),
      safeEndDate: safeEndDate?.toISOString?.(),
    });
  }, [startDate, endDate, safeStartDate, safeEndDate]);
  const selectionRange = React.useMemo(
    () => ({
      startDate: safeStartDate,
      endDate: safeEndDate,
      key: 'selection',
    }),
    [safeStartDate, safeEndDate],
  );

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const formatDate = (date) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
      return 'Select range';
    }

    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  const handleChange = (e) => {
    if (typeof onChange === 'function') {
      onChange(e);
    }
    setAnchorEl(null);
  }

  return (
    <React.Fragment>
      <Button aria-describedby={id} variant="contained" color="primary" onClick={handleClick}>
        Date: {formatDate(safeStartDate)} - {formatDate(safeEndDate)}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <BaseDateRangePicker
          ranges={[selectionRange]}
          onChange={handleChange}
        />
      </Popover>
    </React.Fragment>
  );
}

export default DateRangePicker;
